import React, { useCallback } from "react";
import { Input } from "antd";
import { useTranslation } from "react-i18next";

/**
 * Debounced search input component.
 * @param param0 - Props for the component.
 * @returns DebouncedSearch component.
 */
export default function DebouncedSearch({
  setSearchString,
}: {
  setSearchString: (searchString: string) => void;
}) {
  const { t } = useTranslation();

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchString(e.target.value);
    },
    [setSearchString],
  );

  return (
    <div>
      <Input.Search
        allowClear
        onChange={handleChange}
        size="large"
        placeholder={t("translation:search")}
      />
    </div>
  );
}
